"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _recompose = require("../recompose");
var _styled = require("../styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var unique = function unique(item, i, arr) {
  return !!item && arr.indexOf(item) === i;
};
var filterItems = function filterItems(items, key, value) {
  return items.filter(function (item) {
    return (0, _styled.prop)(key)(item) && (0, _styled.prop)(key)(item).split(',').some(function (i) {
      return i.trim() === value.trim();
    });
  });
};
var getFilteredItems = function getFilteredItems(items, filter) {
  return Object.keys(filter).reduce(function (acc, key) {
    return filterItems(acc, key, filter[key]);
  }, items);
};
var getOptions = function getOptions(items, key) {
  return items.map(function (item) {
    return (0, _styled.prop)(key)(item);
  }).filter(unique).sort();
};
var getAvailableOptions = function getAvailableOptions(items, filter, key) {
  var optionsFilter = Object.assign({}, filter);
  delete optionsFilter[key];
  var filteredItems = getFilteredItems(items, optionsFilter);
  return getOptions(filteredItems, key);
};
var withFilter = function withFilter(_ref) {
  var itemsMapper = _ref.items,
    filtersMapper = _ref.filters;
  return function (ComposedComponent) {
    return function (props) {
      var items = itemsMapper(props);
      var filters = filtersMapper(props) || [];
      var activeFilter = props.activeFilter;
      var optionSets = filters.map(function (key) {
        var availableOptions = getAvailableOptions(items, activeFilter, key);
        var options = getOptions(items, key).map(function (option) {
          return {
            value: option,
            enabled: availableOptions.includes(option)
          };
        });
        if (props.data && props.data.productCategory && props.data.productCategory.filterValues && props.data.productCategory.filterValues.length > 0) {
          var newFilterValues = props.data.productCategory.filterValues;
          var allValues = newFilterValues.filter(function (item) {
            return item.filter === key;
          });
          allValues = allValues && allValues.length > 0 && allValues[0].values;
          var alloptions;
          var mixedOptionsNames = [];
          allValues = allValues.map(function (item) {
            if (Number(item.name) || item.name == "N/A" || item.name == "N/a" || item.name == "n/a" || item.name == "0") {
              mixedOptionsNames.push({
                value: Number(item.name),
                metric: ''
              });
              return item.name;
            }
            if (item.name.indexOf(' ') === -1) {
              return item.name;
            } else {
              var firstItem = item.name.substr(0, item.name.indexOf(' '));
              var rest = item.name.substr(item.name.indexOf(' ') + 1);
              if (Number(firstItem) || firstItem == "N/A" || firstItem == "N/a" || firstItem == "n/a" || firstItem == "0") {
                mixedOptionsNames.push({
                  value: firstItem,
                  metric: rest
                });
              }
              return item.name;
            }
          }).sort();
          if (mixedOptionsNames.length == allValues.length) {
            mixedOptionsNames = mixedOptionsNames.sort(function (a, b) {
              return a.value - b.value;
            });
            allValues = mixedOptionsNames.map(function (item) {
              return item.value + " " + item.metric;
            });
          } else {
            allValues = allValues.sort();
          }
          if (allValues) {
            alloptions = allValues.map(function (option) {
              return {
                value: option,
                enabled: true
              };
            });
            return {
              key: key,
              options: alloptions
            };
          }
        }
        return {
          key: key,
          options: options
        };
      });
      var addedProps = {
        items: getFilteredItems(items, activeFilter),
        filter: activeFilter,
        options: optionSets
      };
      return /*#__PURE__*/_react.default.createElement(ComposedComponent, Object.assign({}, props, addedProps));
    };
  };
};
var _default = exports.default = function _default(options) {
  return (0, _recompose.compose)((0, _recompose.withState)('activeFilter', 'setFilter', options.initialValues || {}), (0, _recompose.withHandlers)({
    updateFilter: function updateFilter(_ref2) {
      var setFilter = _ref2.setFilter;
      return function (key, value) {
        return setFilter(function (prev) {
          var next = Object.assign({}, prev);
          if (value == null) {
            delete next[key];
          } else {
            next[key] = value;
          }
          return next;
        });
      };
    }
  }), withFilter(options));
};